module.exports = __webpack_public_path__ + "site/img/index12zh.c95b9753.png";